import NodeToggle from "../components/NodeToggle";
import Interaction from "../../../models/interactions/Interaction";
import { ISetMovementEnabled } from "../../../models/interactions/SetMovementEnabled";
import useUpdateSequenceInteraction from "./UpdateSequenceInteraction.hook";

export default function SetMovementEnabledNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const interaction = props.interaction as ISetMovementEnabled;
  const { updateInteraction } = useUpdateSequenceInteraction();

  return (
    <div className="w-full h-full flex flex-col gap-[12px]">
      <NodeToggle
        label="Movement Enabled"
        value={interaction.movementEnabled}
        onChange={(movementEnabled) =>
          updateInteraction(props.nodeId, {
            ...interaction,
            movementEnabled,
          } as ISetMovementEnabled)
        }
      />
    </div>
  );
}
